import './polyfill';
import 'reflect-metadata';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { unstable_HistoryRouter as Router } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import {
  ThemeProvider as MuiThemeProvider,
  Theme,
  StyledEngineProvider,
} from '@mui/material/styles';

import theme from '@core/theme';
import history from '@shared/utils/history';
import Admin from './apps/Admin';
import Config from '@core/config';
import container from '@core/di';
import AuthManager from '@core/AuthManager';
import HttpClient from '@core/HttpClient';
import { AuthStore } from '@shared/stores';
import Notification from '@shared/components/Notification';
import AuditService from '@shared/services/audit';

declare module '@mui/styles/defaultTheme' {
  interface DefaultTheme extends Theme {}
}

const App = () => {
  const config = container.get<Config>(Config.diToken);
  const authManager = container.get<AuthManager>(AuthManager.diToken);
  const auditorService = container.get<AuditService>(AuditService.diToken);

  config.initialize();
  auditorService.initialize();

  authManager.initialize();

  const authStore = container.get<AuthStore>(AuthStore.diToken);

  authStore.initialize({
    getDeviceId: auditorService.getDeviceId,
  });

  const { apiURL, apiSSO, clientApiURL } = config.get();

  const httpClient = container.get<HttpClient>(HttpClient.diToken);
  httpClient.initialize({
    baseUrl: `${apiURL.origin}${apiURL.pathname}`,
    apiSSOUrl: `${apiSSO.origin}${apiSSO.pathname}`,
    clientApiUrl: `${clientApiURL.origin}${clientApiURL.pathname}`,
    getUserTokens: () => authStore.getUserTokens(),
    handleSignIn: () => {
      authStore.reset();
      authStore.handleLogin();
    },
  });

  return (
    <Router history={history}>
      <StyledEngineProvider injectFirst>
        <MuiThemeProvider theme={theme}>
          <CssBaseline />
          <Notification />
          <Admin />
        </MuiThemeProvider>
      </StyledEngineProvider>
    </Router>
  );
};

createRoot(document.getElementById('root')!).render(<App />);
